import { BorderBox } from "@/components/atoms/BorderBox";
import { QuestionNotInTemplateChangeProps } from ".";
import { ListTodo } from "lucide-react";

export function QuestionNotInTemplateChange({ context }: QuestionNotInTemplateChangeProps) {
    return (
        <BorderBox size={"sm"} className="flex flex-col items-start" >
            <h4 className="flex items-center gap-1 font-semibold"><ListTodo size="16"/>Question is not part of the template</h4>
            <div className="flex flex-col w-full gap-2">
                <div className="text-xs text-muted-foreground">
                    Question: <i><b>{context.question.question}</b></i> will be deleted from the instance.
                </div>
            </div>
        </BorderBox>
    )
}